import AdvantageCard from './AdvantageCard';

const advantageCards = [
  {
    title: 'For Investors',
    description: `
· Pre-vetted borrowers you can choose from
· Transparent data to make informed decisions
· Ready-to-use legal contracts provided upfront by Escrow Company
· A seamless, professional process from start to finish
· Ongoing servicing by trusted partners such as FCI, ensuring professionalism, Transparency, protection, and support throughout the life of your investment`,
    icon: '/investors-advantage-icon.png', // 2nd image (bank/computer)
    iconPosition: 'right',
  },
  {
    title: 'Borrowers',
    description: `
· Direct, competitive financing with no middlemen
· Simple, streamlined paperwork
· Clear approval criteria based on your property
· Fair, tailored terms
· All contracts prepared upfront by Escrow Company
· A smooth, professional process from start to finish
· Ongoing servicing by trusted partners like FCI for transparency, protection, and support throughout your loan`,
    icon: '/pack-of-money-borrowers.png', // 1st image (pack of money)
    iconPosition: 'left',
  },
  {
    title: 'Built-In Intelligence',
    description:
      'Explore opportunities, filter investments, and access clear insights—all in one platform. Make confident decisions quickly with reliable, organized data at your fingertips.',
    icon: '/built-in-inteligence-bot.png', // 3rd image (bot)
    iconPosition: 'right',
  },
];

export default function EquipoolAdvantageSection() {
  return (
    <div className="w-full mt-8 flex justify-center">
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4 md:gap-5" style={{ maxWidth: 1090 }}>
        {advantageCards.map((card) => (
          <AdvantageCard
            key={card.title}
            title={card.title}
            description={card.description}
            icon={card.icon}
            iconPosition={card.iconPosition}
          />
        ))}
      </div>
    </div>
  );
}
